export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL

export const GOOGLE_AUTH_URI = '/auth/google'

export const USER_TO_QUESTIONS_CHOICES_URI = 'user_to_question_choices'
export const USER_TO_QUESTIONS_VOTES_URI = 'user_to_question_votes'
export const ASAKAI_EMAIL_PATH = 'asakai/email'
